import { FiCheck, FiChevronRight, FiX } from 'react-icons/fi';

import { Container, Content } from './styles';
import { StyledButton } from '../StyledButton';

interface IProps {
  type: 'success' | 'error';
  title?: string;
  text: string | React.ReactNode;
  setModal: (value: boolean) => void;
}

const StatusModal = ({ title, text, type, setModal }: IProps) => (
  <Container>
    <Content>
      <div className="icon">
        {type === 'success' ? <FiCheck size={40} /> : <FiX size={40} />}
      </div>

      <div className="title">
        {title && <p>{title}</p>}

        {!title && <p>{type === 'success' ? 'Sucesso' : 'Erro'}</p>}
      </div>

      <div className="text">{text}</div>
      <StyledButton
        icon={<FiChevronRight />}
        iconPosition="right"
        text="Fechar"
        iconWhiteBackground
        iconBorderRadius
        onClick={() => setModal(false)}
      />
    </Content>
  </Container>
);

export { StatusModal };
